import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-191c4e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "d-flex p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "description", {}, undefined, true)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppButton, {
        block: "",
        variant: "outline-dark",
        onClick: _ctx.onClickDecline,
        class: "button mr-1",
        id: "decline-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.declineText), 1)
        ], undefined, true),
        _: 1
      }, 8, ["onClick"]),
      _createTextVNode(),
      _createVNode(_component_AppButton, {
        block: "",
        onClick: _ctx.onClickAccept,
        variant: _ctx.acceptButtonVariant,
        class: "button",
        id: "accept-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.acceptText), 1)
        ], undefined, true),
        _: 1
      }, 8, ["onClick", "variant"])
    ])
  ]))
}